import classnames from 'classnames'
import { useCallback, useMemo } from 'react'

import { STATSIG_EXPERIMENTS_CONFIG, STATSIG_EXPERIMENTS } from '@src/config/statsig-experiments.config'
import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import { useNewPdpDesignV2Bucket } from '@src/quince-site-pdp/src/templates/productPage/hooks/useShowNewPdpDesignV2'

import styles from './product-custom-banner-message.module.scss'
import { getTrackerAddedComboMessageOffer } from './utils'

import type { ProductCustomBannerMessageProps } from './product-custom-banner-message.types'

export const ProductCustomBannerMessageLegacy = (props: ProductCustomBannerMessageProps) => {
  const { productId, customBannerMessageFromPC } = props
  const newPdpDesignV2Bucket = useNewPdpDesignV2Bucket()
  const showNewPdpDesignV2 =
    newPdpDesignV2Bucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.NEW_PDP_DESIGN_V2].buckets?.control
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_custom_banner_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const customBannerMessageWithTracker = useMemo(
    () =>
      customBannerMessageFromPC && productId
        ? getTrackerAddedComboMessageOffer(customBannerMessageFromPC, productId as number)
        : customBannerMessageFromPC,
    [customBannerMessageFromPC, productId],
  )
  return (
    <>
      {!props.hideCustomBannerMessage && customBannerMessageWithTracker && productId && (
        <div
          className={classnames(
            styles.customBannerMessage,
            styles.customBannerMessage_adjustedPadding,
            styles.customBannerMessage__customBannerMessageWithMto,
            styles.customBannerMessage__customBannerMessageWithMto_adjustedPadding,
            showNewPdpDesignV2 && styles.customBannerMessage_newDesignV2,
          )}
          ref={trackIsVisibleRef}
        >
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(customBannerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}
